import { replacePII } from '@wix/wix-chatbot-common/utils';

import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ErrorMessagePresentedBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logResendButtonClicked: BiEventLogger<ErrorMessagePresentedBiData> = async (state, data) => {
  const biData = selectBiData(state);
  const { conversationId = '', nodeId } = biData;
  const { sessionId = '', contextBi } = await getRuntimeDataForBi(state);

  biLogger.resendButtonClicked({
    conversation_id: conversationId,
    node_id: nodeId,
    chatbot_view: contextBi?.chatbot_view,
    session_id: sessionId,
    user_message: replacePII(data.messageText),
    message_id: data.messageId,
    lang: locale,
  });
};
